import React, { useEffect } from "react";
import MainNav from "@/components/MainNav";
import Footer from "@/components/Footer";

const PublicLayout = ({ children }: { children: React.ReactNode }) => {

    useEffect(() => {
    }, []);

    return (
        <div className="min-h-screen flex flex-col bg-gray-50">
            {/* Navigation */}
            <MainNav />

            {/* Main Content */}
            <main className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                {children}
            </main>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default PublicLayout;
